export interface Movie {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  coverImage: string;
  type: 'movie' | 'tv';
  episodes?: number;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const categories = [
  { name: '动作片', slug: 'action', icon: 'ri-sword-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-happy-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '剧情片', slug: 'drama', icon: 'ri-film-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-ancient-gate-line' },
  { name: '电视剧', slug: 'tvseries', icon: 'ri-tv-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    category: '科幻片',
    categorySlug: 'scifi',
    year: 2027,
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。在这段艰辛的旅程中，人类将面对未知的宇宙危险与内部的分裂危机，团结与信念成为生存的唯一希望。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理', '王智'],
    region: '中国大陆',
    duration: '173分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20style%20with%20astronaut%20helmet%20and%20glowing%20earth%20in%20space%2C%20dramatic%20cinematic%20lighting%2C%20deep%20blue%20and%20orange%20color%20scheme%2C%20dark%20atmosphere%2C%20movie%20poster%20composition%2C%20clean%20background&width=600&height=800&seq=movie-cover-1&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['科幻', '灾难', '冒险'],
  },
  {
    id: '2',
    title: '满江红2',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2026,
    rating: 8.9,
    description: '南宋绍兴年间，岳飞死后第四年，秦桧率兵与金国会谈。一桩离奇命案牵扯出惊天阴谋，小兵张大与亲兵营副统领孙均被迫卷入其中，在限定时辰内揭开层层迷雾。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    region: '中国大陆',
    duration: '159分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20palace%20courtyard%20and%20red%20lanterns%2C%20mysterious%20atmosphere%2C%20traditional%20Chinese%20architecture%2C%20dramatic%20red%20and%20black%20tones%2C%20cinematic%20composition&width=600&height=800&seq=movie-cover-2&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['历史', '悬疑', '喜剧'],
  },
  {
    id: '3',
    title: '哪吒之魔童闹海',
    category: '动漫',
    categorySlug: 'anime',
    year: 2025,
    rating: 9.5,
    description: '天劫之后，哪吒和敖丙灵魂虽保住了，但肉身即将消散。太乙真人打算用七色宝莲为二人重塑肉身，然而在重塑过程中却遇到了前所未有的困难。哪吒与敖丙的命运将何去何从？',
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '囧森瑟夫'],
    region: '中国大陆',
    duration: '144分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20featuring%20mythological%20warrior%20boy%20with%20flaming%20hair%20and%20red%20sash%2C%20dynamic%20action%20pose%2C%20vibrant%20fire%20effects%2C%20oriental%20art%20style%2C%20epic%20composition&width=600&height=800&seq=movie-cover-3&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['动画', '奇幻', '神话'],
  },
  {
    id: '4',
    title: '暴裂无声',
    category: '动作片',
    categorySlug: 'action',
    year: 2024,
    rating: 8.7,
    description: '北方某矿业小镇接连发生失踪案件，哑巴矿工张保民在寻找失踪儿子的过程中，意外卷入了一场关于利益、权力和真相的黑暗漩涡。',
    director: '忻钰坤',
    actors: ['宋洋', '姜武', '袁文康', '谭卓'],
    region: '中国大陆',
    duration: '120分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20Chinese%20crime%20thriller%20movie%20poster%20with%20lonely%20man%20silhouette%20in%20mining%20town%20landscape%2C%20gritty%20realistic%20style%2C%20cold%20grey%20tones%2C%20mysterious%20atmosphere%2C%20cinematic%20noir&width=600&height=800&seq=movie-cover-4&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['犯罪', '悬疑', '剧情'],
  },
  {
    id: '5',
    title: '热辣滚烫2',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.5,
    description: '乐莹在拳击比赛中失利后，并没有放弃对生活的热爱。她重新振作起来，开了一家小小的拳击馆，用自己的经历鼓舞了更多普通人勇敢追求梦想。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    region: '中国大陆',
    duration: '130分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20confident%20woman%20in%20boxing%20gloves%2C%20warm%20golden%20lighting%2C%20inspirational%20uplifting%20mood%2C%20bright%20and%20energetic%20color%20palette&width=600&height=800&seq=movie-cover-5&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['喜剧', '励志', '运动'],
  },
  {
    id: '6',
    title: '庆余年第二季',
    category: '电视剧',
    categorySlug: 'tvseries',
    year: 2024,
    rating: 9.0,
    description: '范闲从北齐归来后，发现京都早已暗流涌动。二皇子与长公主的势力日益壮大，而庆帝对范闲的态度也变得微妙起来。面对重重危机，范闲将如何破局？',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟', '宋轶'],
    region: '中国大陆',
    duration: '36集',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20TV%20drama%20poster%20with%20handsome%20man%20in%20ancient%20robe%20holding%20sword%2C%20palace%20background%2C%20elegant%20traditional%20aesthetic%2C%20rich%20gold%20and%20crimson%20tones&width=600&height=800&seq=movie-cover-6&orientation=portrait',
    type: 'tv',
    episodes: 36,
    isHot: true,
    isNew: false,
    tags: ['古装', '权谋', '武侠'],
  },
  {
    id: '7',
    title: '孤注一掷2',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2025,
    rating: 8.8,
    description: '程序员潘生与模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。在经历了种种非人折磨后，他们决定联手反抗，寻找逃出生天的机会。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    region: '中国大陆',
    duration: '135分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20movie%20poster%20with%20digital%20screen%20reflections%20on%20faces%2C%20dark%20cyberpunk%20aesthetic%2C%20red%20alarm%20tones%2C%20suspenseful%20cinematic%20style&width=600&height=800&seq=movie-cover-7&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['犯罪', '剧情', '现实题材'],
  },
  {
    id: '8',
    title: '爱情神话',
    category: '爱情片',
    categorySlug: 'romance',
    year: 2024,
    rating: 8.6,
    description: '上海老白是一位离异的中年画家，他周旋在三个完全不同的女人之间——前妻蓓蓓、心仪的李小姐和意外闯入的格洛瑞亚。在上海这座充满烟火气的城市里，一段轻松幽默又不乏温情的中年爱情故事徐徐展开。',
    director: '邵艺辉',
    actors: ['徐峥', '马伊琍', '吴越', '倪虹洁', '周野芒'],
    region: '中国大陆',
    duration: '111分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20romantic%20comedy%20movie%20poster%20with%20Shanghai%20cityscape%20and%20couple%20walking%2C%20soft%20evening%20light%2C%20gentle%20romantic%20atmosphere%2C%20elegant%20urban%20aesthetic&width=600&height=800&seq=movie-cover-8&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['爱情', '喜剧', '都市'],
  },
  {
    id: '9',
    title: '异形：夺命舰',
    category: '恐怖片',
    categorySlug: 'horror',
    year: 2024,
    rating: 8.4,
    description: '一群年轻的太空殖民者在一座废弃的空间站深处进行 scavenge 时，意外唤醒了宇宙中最可怕的生物——异形。在密闭的空间站中，他们必须想尽办法生存下去。',
    director: '费德·阿尔瓦雷兹',
    actors: ['卡莉·史派妮', '伊莎贝拉·莫塞德', '大卫·荣松'],
    region: '美国',
    duration: '119分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20sci-fi%20horror%20movie%20poster%20with%20alien%20creature%20silhouette%20in%20spaceship%20corridor%2C%20ominous%20red%20emergency%20lighting%2C%20claustrophobic%20atmosphere%2C%20deep%20shadow%20and%20suspense&width=600&height=800&seq=movie-cover-9&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['科幻', '恐怖', '惊悚'],
  },
  {
    id: '10',
    title: '长相思',
    category: '电视剧',
    categorySlug: 'tvseries',
    year: 2025,
    rating: 8.7,
    description: '上古时期，人神魔混居。皓翎国王姬玖瑶在经历了百年的颠沛流离后，不仅失去了身份和容貌，还化为男儿身在清水镇落脚。当命运让她与涂山璟、相柳、玱玹三位迥异的男子相遇，一段刻骨铭心的爱恨纠葛就此展开。',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    region: '中国大陆',
    duration: '45集',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20drama%20poster%20with%20beautiful%20woman%20in%20ethereal%20ancient%20costume%2C%20floating%20peach%20blossoms%2C%20dreamy%20pastel%20color%20palette%2C%20mythological%20xianxia%20aesthetic&width=600&height=800&seq=movie-cover-10&orientation=portrait',
    type: 'tv',
    episodes: 45,
    isHot: true,
    isNew: false,
    tags: ['古装', '奇幻', '爱情'],
  },
  {
    id: '11',
    title: '出走的决心',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2025,
    rating: 8.9,
    description: '李红是一位五十多岁的家庭主妇，半生都在为家庭付出。当女儿长大成人，丈夫也事业有成时，她突然意识到自己从未为自己活过。于是她做了一个惊人的决定——独自驾车穿越中国。',
    director: '尹丽川',
    actors: ['咏梅', '姜武', '吴倩'],
    region: '中国大陆',
    duration: '106分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20road%20trip%20drama%20movie%20poster%20with%20middle-aged%20woman%20driving%20car%20on%20open%20highway%2C%20vast%20landscape%2C%20warm%20sunset%20light%2C%20freedom%20and%20self-discovery%20theme&width=600&height=800&seq=movie-cover-11&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['剧情', '家庭', '公路'],
  },
  {
    id: '12',
    title: '奥本海默',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2023,
    rating: 9.3,
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间领导曼哈顿计划制造原子弹的故事，以及战后他所面临的政治迫害和道德拷问。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    region: '美国',
    duration: '180分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20historical%20biopic%20movie%20poster%20with%20man%20silhouette%20and%20mushroom%20cloud%20explosion%2C%20stark%20black%20and%20white%20contrast%2C%20dramatic%20cinematic%20portrait%2C%20intense%20atmosphere&width=600&height=800&seq=movie-cover-12&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['传记', '历史', '剧情'],
  },
  {
    id: '13',
    title: '功夫熊猫5',
    category: '动漫',
    categorySlug: 'anime',
    year: 2026,
    rating: 8.3,
    description: '阿宝这次面临了前所未有的挑战——一位来自远古的邪恶功夫大师复活了，他拥有着比任何对手都强大的力量。为了保卫和平谷，阿宝必须找到传说中的神龙秘籍的下落。',
    director: '迈克·米切尔',
    actors: ['杰克·布莱克', '安吉丽娜·朱莉', '成龙'],
    region: '美国',
    duration: '95分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Animated%20kung%20fu%20panda%20movie%20poster%20with%20giant%20panda%20in%20dynamic%20martial%20arts%20pose%2C%20colorful%20Chinese%20landscape%20background%2C%20energetic%20and%20playful%20style%2C%20vibrant%20animation%20aesthetic&width=600&height=800&seq=movie-cover-13&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['动画', '喜剧', '动作'],
  },
  {
    id: '14',
    title: '飞驰人生3',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.6,
    description: '曾经的拉力赛车手张驰在经历了人生的起起伏伏后，决定重返赛场。这一次，他不再是孤军奋战——一支由老友和新伙伴组成的草根车队，将与他一起追逐最后的梦想。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    region: '中国大陆',
    duration: '128分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20rally%20car%20speeding%20on%20desert%20track%2C%20dust%20trail%2C%20dynamic%20action%2C%20warm%20sunset%20colors%2C%20adventurous%20spirit&width=600&height=800&seq=movie-cover-14&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['喜剧', '运动', '励志'],
  },
  {
    id: '15',
    title: '封神第二部',
    category: '动作片',
    categorySlug: 'action',
    year: 2025,
    rating: 8.8,
    description: '殷商大军压境，姬发率领西岐军民奋起反抗。姜子牙与哪吒、杨戬等众仙相助，一场关乎天下苍生的大战即将展开。而纣王与妲己背后的黑暗势力也逐渐浮出水面。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰', '娜然'],
    region: '中国大陆',
    duration: '150分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20in%20battle%2C%20grand%20scale%20war%20scene%2C%20mythical%20creatures%2C%20dramatic%20gold%20and%20crimson%20tones&width=600&height=800&seq=movie-cover-15&orientation=portrait',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['奇幻', '动作', '神话'],
  },
  {
    id: '16',
    title: '好东西',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2024,
    rating: 8.9,
    description: '单身妈妈王铁梅带着女儿搬进了新家，结识了邻居小叶。两个性格迥异的女人与王铁梅的女儿之间，发生了一系列温暖又有趣的故事，关于成长、关于爱、关于什么是真正的好东西。',
    director: '邵艺辉',
    actors: ['宋佳', '钟楚曦', '章宇', '赵又廷'],
    region: '中国大陆',
    duration: '123分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20slice-of-life%20comedy%20movie%20poster%20with%20two%20women%20laughing%20in%20cozy%20apartment%2C%20warm%20natural%20light%2C%20urban%20lifestyle%20aesthetic%2C%20heartwarming%20and%20authentic&width=600&height=800&seq=movie-cover-16&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '剧情', '女性'],
  },
  {
    id: '17',
    title: '地球脉动III',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2024,
    rating: 9.7,
    description: 'BBC史诗级自然纪录片系列第三季，历时五年拍摄，跨越六大洲四十三个国家。从深海到山巅，从极地到雨林，用震撼人心的镜头语言讲述地球上最不可思议的生命故事。',
    director: 'BBC Studios',
    actors: ['大卫·爱登堡'],
    region: '英国',
    duration: '8集',
    coverImage: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20poster%20with%20diverse%20wildlife%20collage%2C%20eagle%20soaring%20over%20mountain%2C%20whale%20in%20deep%20ocean%2C%20lush%20rainforest%2C%20vibrant%20natural%20colors%2C%20epic%20scale&width=600&height=800&seq=movie-cover-17&orientation=portrait',
    type: 'tv',
    episodes: 8,
    isHot: false,
    isNew: true,
    tags: ['自然', '纪录片', 'BBC'],
  },
  {
    id: '18',
    title: '饥饿站台2',
    category: '恐怖片',
    categorySlug: 'horror',
    year: 2025,
    rating: 7.8,
    description: '在一个被称为"坑"的垂直监狱中，每天有一桌丰盛的食物从顶层逐层下降。上层的人可以尽情享用，而下层的人只能吃残羹冷炙，甚至什么都没有。一位新来的囚犯试图打破这个残酷的规则。',
    director: '加尔德·加兹特鲁·乌鲁蒂亚',
    actors: ['米莱娜·斯密特', '霍威克·库奇科利安'],
    region: '西班牙',
    duration: '101分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dystopian%20horror%20movie%20poster%20with%20vertical%20prison%20shaft%20and%20descending%20platform%2C%20stark%20minimalist%20design%2C%20cold%20industrial%20tones%2C%20oppressive%20atmosphere&width=600&height=800&seq=movie-cover-18&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['惊悚', '科幻', '人性'],
  },
  {
    id: '19',
    title: '你想活出怎样的人生',
    category: '动漫',
    categorySlug: 'anime',
    year: 2024,
    rating: 8.5,
    description: '少年牧真人在母亲去世后，随父亲搬到乡下。在那里，一只会说话的苍鹭将他引入了一座神秘的塔楼，开启了一段奇幻冒险。这是一部关于生命、死亡与成长的深刻寓言。',
    director: '宫崎骏',
    actors: ['山时聪真', '菅田将晖', '柴崎幸', '木村拓哉'],
    region: '日本',
    duration: '124分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20animated%20movie%20poster%20with%20boy%20and%20mysterious%20heron%20in%20magical%20forest%2C%20whimsical%20fantasy%20atmosphere%2C%20soft%20watercolor%20texture%2C%20dreamy%20pastel%20color%20palette&width=600&height=800&seq=movie-cover-19&orientation=portrait',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['动画', '奇幻', '成长'],
  },
  {
    id: '20',
    title: '长安十二时辰',
    category: '电视剧',
    categorySlug: 'tvseries',
    year: 2025,
    rating: 9.1,
    description: '天宝三载，上元节前夕，长安城混入可疑人员。死囚张小敬临危受命，与少年名士李必携手在十二时辰内揪出幕后黑手，拯救长安城于危难之中。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    region: '中国大陆',
    duration: '48集',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20thriller%20TV%20drama%20poster%20with%20ancient%20Tang%20dynasty%20cityscape%20and%20lanterns%2C%20mysterious%20night%20atmosphere%2C%20intricate%20period%20costume%2C%20rich%20gold%20and%20crimson&width=600&height=800&seq=movie-cover-20&orientation=portrait',
    type: 'tv',
    episodes: 48,
    isHot: true,
    isNew: false,
    tags: ['古装', '悬疑', '历史'],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '李同学',
    avatar: '',
    rating: 5,
    content: '6080影院真的太棒了！高清画质完全不卡顿，而且完全免费。我在上面看完了整部《流浪地球3》，体验感比很多付费平台还好。强烈推荐给所有喜欢看电影的朋友！',
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '王先生',
    avatar: '',
    rating: 5,
    content: '作为一个电影迷，6080影院是我每天必逛的网站。片源更新快，分类清晰，找片子特别方便。已经推荐给身边所有同事了，大家都说好用。',
    date: '2026-07-10',
  },
  {
    id: 3,
    name: '小美',
    avatar: '',
    rating: 4,
    content: '追剧党的福音！《庆余年第二季》刚更新就能在这里看到高清版，不用等不用缓冲。希望片库能再丰富一些，特别是多一些经典老片就更好了。',
    date: '2026-06-28',
  },
  {
    id: 4,
    name: '张大叔',
    avatar: '',
    rating: 5,
    content: '年纪大了不太会用复杂的APP，6080影院的界面很简洁，操作方便。最重要的是播放流畅，画质清晰，在家就能享受影院级的观影体验。',
    date: '2026-06-20',
  },
  {
    id: 5,
    name: '赵女士',
    avatar: '',
    rating: 5,
    content: '孩子们放假在家，6080影院成了我们全家的娱乐中心。动画片资源多，孩子看得开心，我和老公也能找到自己喜欢的电影。真的是宝藏网站！',
    date: '2026-06-15',
  },
];

export const faqs = [
  {
    question: '6080影院是免费的吗？',
    answer: '是的，6080影院完全免费！我们致力于为广大影迷提供高清电影免费在线观看服务，无需注册、无需付费，打开网站即可畅享海量影视资源。无论是最新上映的大片还是经典老片，都可以免费观看。',
  },
  {
    question: '6080影院的画质怎么样？',
    answer: '6080影院提供高清在线影院级画质，所有影片均采用高清视频播放技术，画质清晰细腻。我们持续优化视频编码和CDN加速，确保高清视频播放流畅不卡顿，给您带来影院般的观影体验。',
  },
  {
    question: '怎么在6080影院上找到想看的电影？',
    answer: '在6080影院找影片非常方便！您可以通过首页的搜索功能直接搜索影片名称，也可以通过分类导航按类型（动作片、喜剧片、爱情片、科幻片、恐怖片等）浏览，还能在首页看到热门推荐和最新上线的影片。',
  },
  {
    question: '6080影院支持哪些设备观看？',
    answer: '6080影院支持电脑、平板、手机等多种设备在线观看。我们的网站采用响应式设计，会根据您的设备自动调整页面布局，无论使用什么设备都能获得良好的观影体验。',
  },
  {
    question: '6080影院上的影片更新快吗？',
    answer: '非常快！6080影院的片源更新团队全天候工作，确保在影片上映后第一时间为您提供高清在线观看服务。热门电影和电视剧全集都会及时上线，让您不再错过任何精彩内容。',
  },
  {
    question: '观看时需要安装播放器或插件吗？',
    answer: '不需要！6080影院采用先进的Web播放技术，直接在浏览器中播放高清视频，无需下载或安装任何播放器、插件或APP。打开网页就能看，简单又安全。',
  },
];